// Take data object
// Displat all rows of data and specific columns in a table
// Allow user to pick row(s) of data
// Return picked data or indexes of picked data from object

import React, { useState, useMemo, useRef, useEffect } from 'react';
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

// Used to sort text values case insensitive
const textComparator = (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};

// Used to sort date strings in the form mm/dd/yyyy
function dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
  
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
  
    return date1Number - date2Number;
}
// eg 29/08/2004 gets converted to 20040829
function monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }

    const yearNumber = Number.parseInt(date.substring(6, 10));
    const monthNumber = Number.parseInt(date.substring(0, 2));
    const dayNumber = Number.parseInt(date.substring(3, 5));

    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

// Displays a table of responses that the user can select frmo
function RecordTable( {questions, records, onSelectionSaved} ) {
    // Define columns
    const columnDefs = [
        {field: 'date', flex: 1, comparator: dateComparator, filter: true, checkboxSelection: true },
        {field: 'name', flex: 1, comparator: textComparator},
        {field: 'company', flex: 1, comparator: textComparator}
    ];

    // Format the entire record data to just the columns needed for the table and and id
    let tableRecords = []
    records.forEach(row => {
        let date = row[2].split(" ")[0];
        let rowName = row[10] !== null ? `${row[9]} ${row[10]}` : row[9];
        tableRecords.push({id: row[0], date: date, name: rowName, company: row[11]})
    });
    
    const gridRef = useRef();
    const rowSelected = useRef(true);
    const defaultColDef = useMemo( ()=> {
        return {
        sortable: true
        }
    }, []);

    const onGridReady = (params) => {
        const button = document.getElementById("nextButton");
        if (button) {
          button.disabled = true;
        }
    }
    const onSelectionChanged = () => {
        // if (gridRef.current.api.getSelectedRows().length >= 1) {
        let selectedRowCount = gridRef.current.api.getSelectedRows();
        if (selectedRowCount.length >= 1) {
            console.log("Yes")
            rowSelected.current = true;
        } else {
            console.log("No")
            rowSelected.current = false;
        }
        const button = document.getElementById("nextButton");
        if (button) {
          button.disabled = rowSelected.current === false;
          button.onclick = {saveSelectedRecords};
        }
        console.log(rowSelected);
    }

    const saveSelectedRecords = () => {
        console.log("Saving");
        const selectedRows = gridRef.current.api.getSelectedRows();
        let selectedRecords = [];
        for (const row of selectedRows) {
            for (const record of records) {
                if (row["id"] === record[0]) {
                    selectedRecords.push(record);
                }
            }
        }
        // console.log(selectedRecords);
        onSelectionSaved(selectedRecords);
        
        // console.log(selectedRecords);
    }

    return(
        <div className="record-table">
            <div className="ag-theme-alpine">
                <AgGridReact
                    ref = {gridRef}
                    onGridReady={onGridReady}
                    rowData = {tableRecords}
                    columnDefs = {columnDefs}
                    defaultColDef = {defaultColDef}
                    rowSelection = 'multiple'
                    suppressRowClickSelection = {true}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
            <button className="Primary-button-medium" id="nextButton" onClick={saveSelectedRecords}>Next</button>
        </div>
    )
}

export default RecordTable;